import type { ReactNode } from 'react';
import { BrandEmblem } from '../brand/BrandLogo';

export function FullScreenMessage({ title, body, children }: { title: string; body?: string; children?: ReactNode }) {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-5 px-6 text-center">
      <BrandEmblem size={72} />
      <div>
        <h1 className="text-xl font-bold">{title}</h1>
        {body && <p className="mx-auto mt-2 max-w-sm text-[15px] text-ink-2">{body}</p>}
      </div>
      {children}
    </main>
  );
}
